import React from 'react';
export default function DotButton(props) {
  return (
    <div className='circle-container'>
      <div role='button' aria-label={`Go to slide ${props.index+1}`} tabIndex={0} className={props.selected ? 'circle selected' : 'circle'} onClick={ props.enableDotsButton ? props.onClick : undefined} onKeyDown={props.onKeyDown}>
      </div>
    </div>
  );
}